import { createContext } from 'react';
import {ID, Response} from '../../../../../_dashboard/helpers'
import { string } from 'yup';

export type Role = {
  name: string,
  _id?: string,
  id?: string
}

export interface Category {
  Title:string,
  Star: number,
}

export interface City {
  id?: number;
  name: string;
  country: string;
}
export interface Facility {
  title: string;
  category: string;
  translations: Array<{ title: string }>;

   
  
}
export interface Option {
  title: string;
}
export interface TourTranslation {
  _id: string;
  tour_id: string;
  language: string;
  title: string;
  description: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
}

export interface Tour {
  _id: string;
  title: string;
  content?: string;
  youtubeVideo?: string;
  minAdvanceReservations: number;
  tourMinPeople: number;
  tourMaxPeople: number;
  duration: number;
  durationUnit?: 'hours' | 'days';
  status: 'draft' | 'published';
  availabilityStatus: string;
  translations: TourTranslation[];
  gallery: string[];
  faqs: any[];
  events: any[];
  bannerImage: string[];
  contentCategories: any[];
  createdAt: string;
  updatedAt: string;
  __v: number;
  id: string;
}

export type ToursQueryResponse = Response<Array<Tour>>;
export type QueryResponseTourContextProps<T> = {
  dataResponse?: Response<Array<T>> | undefined
  refetchData: () => void
  isLoading: boolean
  query: any
}
export function createTourResponseContext<T>(initialState: QueryResponseTourContextProps<T>) {
  return createContext(initialState)
}
export const initialTourQueryResponse = { refetchData: () => { }, isLoading: false, query: '' }